const colors = {
  primary: "#99CD50",
  secondary: "#00B1DA",
  bgPrimary: "#FAFCF6",
  bgSecondary: "#00B1DA0D",
  white: "#FFFFFF",
  black: "#000000",
};

export { colors };
